import { createRoot } from 'react-dom/client';
import App from './App';
import 'tailwindcss/tailwind.css';
import './App.css';
import { ThemeProvider } from './context/ThemeContext';
import { setupWebGlobals } from './api/setupWebGlobals';

async function boot() {
  try {
    await setupWebGlobals();
  } catch (err) {
    document.body.innerHTML = `<div style="color:red;padding:2rem;font-family:monospace">
      Failed to load configuration: ${(err as Error).message}<br>
      Make sure the server is running at the same origin.
    </div>`;
    return;
  }

  const container = document.getElementById('root') as HTMLElement;
  const root = createRoot(container);
  root.render(
    <ThemeProvider>
      <App />
    </ThemeProvider>,
  );
}

boot();
